<template>
    <div class="download">
        <banner :title="$t('download.title')"/>
        <div class="download-card">
            <el-button
                type="success"
                v-for="(item,index) in tableDataType"
                :key="index"
                @click="changeData(item,index)"
                :style="{'background': selectedIndex === index ? '#67C23A' : 'linear-gradient(135deg, #6e8efb, #4a6cf7)', 'border-radius': '20px', 'color': 'white', 'border': 'none', 'padding': '10px 20px', 'margin': '5px'}"
                class="hover-effect"
            >{{ item }}</el-button>
            <br>
            <br>
            <el-table
                border
                :data="tableData"
                style="width: 100%; border: none;"
                :header-cell-style="{'text-align':'center', 'background-color': '#f5f7fa', 'font-weight': 'bold'}"
                :row-style="{'cursor': 'pointer', 'transition': 'background-color 0.3s ease'}"
                class="hover-effect"
            >
                <el-table-column :label="$t('download.name')">
                    <template slot-scope="scope">
                <span
                    :title="$t('download.clickToDownload')"
                    style="font-size: 14px; vertical-align: middle; cursor: pointer; color: #409EFF;"
                    @click="download(scope.row.Img)"
                >{{scope.row.Name}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Id" :label="$t('download.download')" width="150px" :style="{'text-align':'center'}">
                    <template slot-scope="scope">
                        <i
                            class="el-icon-download"
                            :title="$t('download.clickToDownload')"
                            style="font-size: 14px; vertical-align: middle; cursor: pointer; color: #409EFF;"
                            @click="download(scope.row.Img)"
                        ></i>
                    </template>
                </el-table-column>
            </el-table>
        </div>

    </div>
</template>


<script>
import Banner from "../components/Banner";
import Vue from "vue";

export default {
    components: {
        Banner
    },
    data() {
        return {
            tableDataAll: [],
            tableData: [],
            tableDataType: [],
            selectedIndex: -1, // 初始值为 -1，表示没有选中任何按钮
        };
    },
    methods: {
        download(url){
            window.open(Vue.prototype.imgserver + url)
        },
        changeData(index,index1){
            this.selectedIndex = index1; // 更新选中状态
            this.tableData = this.tableDataAll[index];
        },
        loadData() {
            this.loading = true;
            this.$http
                .get(`Xzzx`)
                .then(response => {
                    this.tableDataAll = response.data.data.data;
                    this.tableDataType = response.data.data.type;
                    this.tableData = response.data.data.all;
                })
                .catch(function (error) {
                    window.console.log(error);
                });
        }
    },
    mounted() {
        this.loadData();
    },
    watch: {
        newstype(type) {
            window.console.log(type);
            this.loadData();
        }
    }
};
</script>

<style lang="scss" scoped>
    .download-card {
        text-align: center;
        width: 90%;
        max-width: 1200px;
        padding: 50px 5%;
        background-color: white;
        border-radius: 10px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        margin: 0 auto;
    }

    .hover-effect:hover {
        background-color: #f0f2f5;
        transform: scale(1.02);
        transition: transform 0.3s ease, background-color 0.3s ease;
    }

    @media (max-width: 768px) {
        .download-card {
            width: 100%;
            max-width: 100%;
            padding: 20px 12px;
            box-sizing: border-box;
            border-radius: 0;
        }

        .el-table {
            font-size: 12px;
        }
    }
</style>